module.exports = __webpack_public_path__ + "assets/img/prize2-b6bc3272.png";